/**
 * 饼图验证配置
 * 为新 ValidationEngine 提供验证规则
 */

import type { ValidationConfig } from '../../../core/dataProcessor/types';

// 🆕 为新 ValidationEngine 导出的配置
export const pieValidationConfig: ValidationConfig = {
  fields: [
    { field: 'x', type: 'string', required: true },
    { field: 'y', type: 'number', required: true }
  ],
  businessRules: [
    {
      name: 'pie-data-size-warning',
      validator: data => {
        if (!Array.isArray(data)) {
          return false;
        }
        return data.length <= 10;
      },
      message: 'Pie chart works best with 10 or fewer slices',
      suggestion: 'Consider using a bar chart for more than 10 categories',
      severity: 'warning'
    },
    {
      name: 'pie-unique-categories',
      validator: (data, layer) => {
        const { encoding } = layer;
        if (data.length === 0) {
          return true;
        }
        const categories = new Set(data.map(item => item[encoding?.x as string]));
        return categories.size === data.length;
      },
      message: 'Pie chart categories should be unique',
      suggestion: 'Ensure all x field values are unique for accurate representation',
      severity: 'warning'
    },
    {
      name: 'pie-non-negative-values',
      validator: (data, layer) => {
        if (!Array.isArray(data)) {
          return false;
        }
        const { encoding } = layer;
        return data.every(item => {
          const value = item[encoding?.y as string] as number;
          return value >= 0;
        });
      },
      message: 'Pie chart values must be non-negative',
      suggestion: 'Ensure all y field values are non-negative numbers',
      severity: 'error'
    }
  ]
};
